import {DataARClaimModel} from '../../../models/accountsReceivable/data-ar-claim.model';
import {DataARClaimItemListModel} from './data-ar-claim-item-list';
import {enumValidValueItem} from '../_models/ar.models';

export class DataARClaimListModel extends DataARClaimModel {
  DoctorFirstName: string;
  DoctorLastName: string;
  DoctorFullName: string;
  PatientID: string;
  PatientFirstName: string;
  PatientLastName: string;
  PatientInsuranceName: string;
  LocationName: string;
  ClaimItemCount: string;
  ClaimType: string;
  ClaimStatus: string;
  ClaimAmount: number;
  ClaimAmountOutstanding: number;
  InsEstimateAmountTotal: number;
  InsEstimateAmountDue: number;
  dataARClaimListItems: DataARClaimItemListModel[];
  ApplyPayment: number;
  AmountDue: number;
  MarkedForClose: boolean;
  ClosedSearchResultSort: number;
  ARTransactionItemID: string;
  InsuranceOrder: number;

  DATA_SELECTED: boolean;
  enumARLedgerItemType: enumValidValueItem;
  searchResult: boolean = false;
  claimExpanded: boolean = false;
}
